import React, { useState,useContext, useEffect } from "react";
import Moment from "react-moment";
import { useHistory } from "react-router-dom";
import AppContext from "../../Context/AppContext";
import GestorInfo from "./GestorInfo/GestorInfo";
import { KTSVG, toAbsoluteUrl } from "../../helpers";
import { DataTable } from "../Common/Controls/Controls";
import requestAxios from "../../util/requestAxios";
import "./Inicio.css";
const Inicio = () => {
  const { checkUserSession } = useContext(AppContext);
  const history = useHistory();
  const [datatable, setDatatable] = React.useState({
    columns: [
      {
        label: " ",
        field: "objFind",
        width: 0,
      },
      {
        label: "",
        field: "TipoGestionId",
        width: 50,
      },
      {
        label: "Nombre/Expediente",
        field: "Nombre",
        width: 150,
        attributes: {
          "aria-controls": "DataTable",
          "aria-label": "Name",
        },
      },
      {
        label: "Comentario",
        field: "Comentario",
        width: 270,
      },
      {
        label: "Fecha",
        field: "Fecha",
        width: 200,
      },

      {
        label: "Tipo Gestión",
        field: "TipoGestion",
        sort: "disabled",
        width: 150,
      },
      {
        label: "",
        field: "AcreditadoId",
        sort: "disabled",
        width: 100,
      },
    ],
    rows: [],
  });
  const [correspondecia, setCorrespondencia] = useState([]);
  useEffect(() => {
    loadInfo();
  }, []);
  async function loadInfo() {
    const infoUs = checkUserSession();
    const { error, data } = await requestAxios({
      url: `Acreditados/getRegistrosMes`,
      method: "get",
      token: infoUs.bearer_token,
      data: {},
    });
    if (error === "") {
      if (data.countTipoGestion.length > 0) {
        setCorrespondencia(data.countTipoGestion);
      }
      if (data.RegistrosMes.length > 0) {
        setDatatable({
          ...datatable,
          rows: data.RegistrosMes.map((item, i) => ({
            objFind: `${item.Nombre} ${item.AcreditadoId} ${item.Comentario} ${item.Fecha} ${item.ClaveGestor} ${item.TipoGestion}`,

            TipoGestionId: (
              <div
                className={`StatusDataTable__container Status${item.TipoGestion}DataTable__container`}
              >
                {"S"}
              </div>
            ),
            Nombre: (
              <>
                <h1>{item.Nombre}</h1>
                <h4>{item.AcreditadoId}</h4>
              </>
            ),
            Comentario: (
              <div className="comentarioDataTable">{item.Comentario}</div>
            ),
            Fecha: (
              <Moment locale="es" format="DD-MMM-YYYY" date={item.Fecha} />
            ),

            TipoGestion: item.TipoGestion,
            AcreditadoId: (
              <button
                className="btnDetalleExpediente"
                onClick={() =>
                  history.push(`./AcreditadosDetalle/${item.AcreditadoId}`)
                }
              >
                Detalles
              </button>
            ),
          })),
        });
      }
    }
  }
  function getSum(arr) {
    if (arr.length > 0) {
      const sum = arr.reduce((acum = 0, item) => {
        return (acum.Cantidad == null ? acum : acum.Cantidad) + item.Cantidad;
      });
      return sum.Cantidad!=null?sum.Cantidad:(sum);
    } else {
      return String(0);
    }
  }

  return (
    <div className="Inicio__container">
      <GestorInfo />
      <div className="InicioTablas__container">
        <div className="mdbDataTable">
          <div className="InicioTitleTable">Tus registros de este mes</div>
          <DataTable hover data={datatable} className="mdbDataTableInicio" />
        </div>
        <div className="InicioTablaTotales__container">
          <h1 className="InicioTablaTotales__title">
            Tus Gestiónes de este mes
            <span className="itemCantidad__title">
              +{getSum(correspondecia)}
            </span>
          </h1>
          {correspondecia.map((item, i) => {
            return (
              <div
                key={`InicioTablaTotales__item${i}`}
                className={`InicioTablaTotales__item Status${item.TipoGestionClave}DataTable__container`}
              >
                <KTSVG
                  path={"/img/Menu/Gestion.svg"}
                  className={`svg-icon iconMenuItem${item.TipoGestionClave}`}
                />
                <span>{item.TipoGestionNombre}</span>{" "}
                <div className="itemCantidad__container">+{item.Cantidad}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Inicio;
